import React from "react";

const ProgressLoading = ({ progress, setFieldValue, handleRemoveFile, nameFile }) => {
  return (
    <div className="attach-loader">
      <div className="attach-loader__box">
        <div className="attach-loader__text">Cargando...</div>
        <div
          className="attach-loader__button"
          onClick={() => {
            setFieldValue("vaucher", "");
            handleRemoveFile();
          }}
        >
          Cancelar
        </div>
      </div>
      <progress
        max="100"
        value={progress}
        className={progress <= 90 ? "isOrange" : "isGreen"}
      ></progress>
      <div className="attach-loader__descriptions">
        {progress}% - {nameFile}
      </div>
    </div>
  );
};

export default ProgressLoading;
